<template>
  <section class="section page__content">
    <div class="page__row">
      <div class="page__item">
        <AppInput
          title="Тип заказа"
          :value="orderType.name"
          :valid="validation.name"
          required
          @value-changed="setOrderTypeName"
          @got-focus="clearValidation('name')"
          :disabled="!roleAccessEdit"
        />
      </div>
    </div>

    <div class="page__row">
      <div class="page__item">
        <AppSwitch title="Клиент является юр.лицом"
                   name="orderType"
                   @toggleCheck="setToggleEntity"
                   :onCheck="orderType.is_entity"
                   :disabled="!roleAccessEdit"
        />
      </div>
    </div>
  </section>
</template>

<script>
import AppInput from '@/components/page/input/AppInput'
import AppSwitch from '@/components/page/input/AppSwitch'

export default {
  name: 'PvhOrderTypeUpdateOrder',
  components: {
    AppSwitch,
    AppInput
  },
  computed: {
    orderType () {
      return this.$store.getters['[pvh] getOrderTypeForUpdate']
    },
    validation () {
      return this.$store.getters['[pvh] getOrderTypeUpdateValidation']
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessEdit () {
      return this.$store.getters.getRoleRightPvh.actions.update
    }
  },
  methods: {
    setOrderTypeName (value) {
      return this.$store.commit('[pvh] SET_ORDER_TYPE_UPDATE_NAME', value)
    },
    setToggleEntity () {
      return this.$store.commit('[pvh] SET_ORDER_TYPE_UPDATE_ENTITY')
    },
    clearValidation (value) {
      return this.$store.commit('[pvh] SET_ORDER_TYPE_ITEM_VALIDATION', value)
    }
  }
}
</script>

<style scoped>

</style>
